import { ChangeDetectorRef, Component, inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { FormBuilder, FormControl, FormGroup, FormsModule, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio'
import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { CommonModule, DatePipe } from '@angular/common';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, provideNativeDateAdapter } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MaterialModule } from '../../../material.module';
import { Router, RouterModule } from '@angular/router';
import { TarapiService } from './tarapi.service';
import { TextMaskDateDirective } from '../../../Directives/text-mask-date-directive.directive';
import { CustomDateAdapter } from '../../../Shared/common/ng-date-parse-adapter';
import moment from 'moment';
import Swal from 'sweetalert2';
import { NotesDatashareService } from '../notes/services/notes-datashare.service';
import { RolesModel } from '../../../Data/Models/Users/roles-model';
import { UsermanagementService } from '../../../services/apps/usermanagement/usermanagement.service';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { CharityDetailsModal, TrusteesDataModal } from '../charities/addcharities/CharityDetailsModal';
import { CharitiesService } from '../charities/services/charities.service';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';
import { MessageServiceService } from '../../../Shared/common/message-service.service';
import { EditorModule } from '@tinymce/tinymce-angular';
import { ConfigurationService } from '../../../Configuration/configuration.service';
import { MatSelectChange } from '@angular/material/select';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { InputRestrictionDirective } from '../../../Directives/input-restriction.directive';

@Component({
  selector: 'app-trusteeannualreport',
  imports: [NgScrollbarModule, MaterialModule, MatCardModule, MatRadioModule, EditorModule, FormsModule, MatFormFieldModule, MatInputModule, RouterModule, CommonModule, MatTabsModule, TablerIconsModule, MatDatepickerModule, ReactiveFormsModule, TextMaskDateDirective, InputRestrictionDirective],
  templateUrl: './trusteeannualreport.component.html',
  styleUrl: './trusteeannualreport.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  providers: [{ provide: DateAdapter, useClass: CustomDateAdapter },
  { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS }, DatePipe],
})
export class TrusteeannualreportComponent {
  private apiUrl = this.configService.getAPIBaseUrl();
  @ViewChild('myForm') myForm!: NgForm;
  @ViewChild('sort1') sort1!: MatSort;
  @ViewChild(MatPaginator) paginatorT!: MatPaginator;
  @ViewChild(MatPaginator) paginatorL!: MatPaginator;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  private isInitializing = true;
  showContent = false;
  showContent1 = false;
  apFinalised: boolean = false
  showValidation1: boolean = false;
  showValidation2: boolean;
  showValidation3: boolean;
  showValidation4: boolean;
  showValidation5: boolean;
  showValidation6: boolean;
  showValidation7: boolean;
  showValidation8: boolean;
  showValidation9: boolean;
  showValidation10: boolean;
  showValidation11: boolean;
  showValidation12: boolean;
  showValidation13: boolean;
  showValidation14: boolean;
  showValidation16: boolean;
  startDate: any
  endDate: any
  today: any = moment()
  initialContent1: any;
  initialContent2: any;
  initialContent3: any;
  initialContent4: any;
  initialContent5: any;
  initialContent6: any;
  initialContent7: any;
  initialContent8: any;
  initialContent9: any;
  initialContent10: any;
  initialContent11: any;
  initialContent12: any;
  initialContent13: any;
  initialContent14: any;
  initialContent15: any;
  initialContent17: any;
  initialContent16: any;
  initialContent18: any;
  imageFile: File | null = null;
  showCropper: boolean = false;
  croppedImage: any = '';
  _resolveCrop: any;
  _editingImageSrc: string | null = null;
  trusteeReport: boolean = true;
  StatementofRes: boolean = false;
  declaration: boolean = false;
  ReportType_Method: string | null;
  isIndependentExaminer: boolean = false;
  auditor: boolean = false;
  SubmissionStatus: any;
  showValidationStatement: boolean = false;
  ShowSpinner: any = false;
  trusteeName: any = '';
  trusteesData: any = new MatTableDataSource<any>([]);
  trusteesArray: any;
  search_Trustee: any = null
  gettrusteeData: any = new MatTableDataSource<any>([]);
  filterOver: any = 0;
  registration_Number: any;
  filterTrustee: any = 0;
  btn: boolean;
  chairOfBoardOptions: boolean = false;
  dupNum: any;
  onFirstClick: boolean = false;
  editable: boolean = false;
  selectedTrusteeIndex: any = null;
  skpbtn: boolean;
  skpbtn1: boolean;
  sort2: boolean;
  recordsFound: any;
  charityID: any;
  truFetFrmCharCom: boolean = false;
  backTrustee: boolean = false;
  private _formBuilder = inject(FormBuilder);

  showTrusteeRepport() {
    debugger
    this.trusteeReport = true;
    this.StatementofRes = false;
    this.declaration = false;
  }
  showStatementofRes() {
    debugger
    this.trusteeReport = false;
    this.StatementofRes = true;
    this.declaration = false;
  }


  showDeclaration() {
    debugger
    if (this.isIndependentExaminer) {
      if (this.isDeclarationDisabled()) {
        this.resetDeclarationUI();
      }
      const content = this.statementofTrusteesModal.trusteeStatement || '';
      const plainText = this.stripHtmlTags(content).trim();
      if (!plainText && this.statementofTrusteesModal.includeTAR === 'Yes') {
        this.showValidationStatement = true;
        const editor = (window as any).tinymce?.activeEditor;
        if (editor) {
          editor.focus();
        }
        Swal.fire({
          html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Statement of Trustees’ Responsibility is required</p>',
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          showCancelButton: false,
          allowOutsideClick: false
        })
        return
      }
      this.trusteeReport = false;
      this.StatementofRes = false;
      this.declaration = true;
      this.tarDetails.approvalDate_SecA = this.statementofTrusteesModal.approvalDate
      this.tarDetails.approvedbyTrustee_SecA = this.statementofTrusteesModal.trusteeName
      return;
    }
    if (this.statementofTrusteesModal.includeTAR == 'Yes' || this.tarDetails.annualReport_Status == 'Yes' || this.apFinalised) {
      const content = this.statementofTrusteesModal.trusteeStatement || '';
      const plainText = this.stripHtmlTags(content).trim();
      if (!plainText && this.statementofTrusteesModal.includeTAR === 'Yes') {
        Swal.fire({
          html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Statement of Trustees’ Responsibility is required</p>',
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          showCancelButton: false,
          allowOutsideClick: false
        })
        return
      }
      this.trusteeReport = false;
      this.StatementofRes = false;
      this.declaration = true;
    }
    else {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" >Trustees’ Annual Report or Statement of Trustees’ <br> Responsibility is required</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "OK",
        showCancelButton: false,
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          return true
        } else {
          return false
        }
      })
    }
  }
  trustAdvisor: any = [];
  setVisibility(event: MatRadioChange) {
    debugger
    var charityid = localStorage.getItem('currentCharityID')
    var fid = localStorage.getItem('currentPeriod')
    this.apiservice.GetTAR(fid).subscribe((data: any) => {
      debugger
      this.otherTrustees = []
      this.optionalAdvisers = []
      //this.tarDetails = {
        //taR_Id: 0,
        //this.tarDetails.annualReport_Status = event.value;
        ////nameofChiefExecutive: "",
        ////approvedbyTrustee_SecA: this.tarDetails?.approvedbyTrustee_SecA,
        ////approvalDate_SecA: this.tarDetails?.approvalDate_SecA,
        ////description_SecB: "",
        ////description_SecB_2: "",
        ////description_SecB_3: "",
        ////approvedbyTrustee_SecB: "",
        ////approvalDate_SecB: null,
        ////description_SecC: "",
        ////description_SecC_2: "",
        ////description_SecC_3: "",
        ////description_SecC_4: "",
        ////approvedbyTrustee_SecC: "",
        ////approvalDate_SecC: null,
        ////description_SecD: "",
        ////description_SecFS : "",
        ////approvedbyTrustee_SecD: "",
        ////approvalDate_SecD: null,
        ////description_SecE: "",
        ////description_SecE_2: "",
        ////description_SecE_3: null,
        ////description_SecE_4: "",
        ////description_SecE_5: null,
        ////description_SecE_6: "",
        ////description_SecE_S7: "",
        ////approvedbyTrustee_SecE: "",
        ////approvalDate_SecE: null,
        ////description_SecF: "",
        ////approvedbyTrustee_SecF: "",
        ////approvalDate_SecF: null,
        //rowmsg: null,
        //charityID: 0,
        //createdDate: null,
        //createdby: 1,
        //modifiedby: 1,
        //modifiedDate: null,
        //centralUserId: 1,
        //userId: 1
        this.tarDetails.annualReport_Status = event.value;
      //}
      this.charityInformation = {
        charityID: 0,
        charity_Name: "",
        other_Names: "",
        charity_Registration_Number: "",
        company_Reference_Number: "",
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        city: "",
        county: "",
        country: "",
        postcode: "",
        from_CharityCommission: ""
      }
      if (data.otherTrustees) {
        this.otherTrustees = data.otherTrustees
      }
      if (data.optionalAdvisers?.length > 0) {
        this.optionalAdvisers = data.optionalAdvisers
      }
      if (data.trustees) {
        this.trustees = data.trustees
        //  this.trustAdvisor = this.trustAdvisor.filter((examiner: any) => this.trustAdvisor.professionalAdvisors_Type?.toLowerCase() === "independent examiner");
      }
      if (data.charityInformation) {
        this.charityInformation = data.charityInformation
      }
      if ((localStorage.getItem('ReportType_Method') != 'Independent Examiner') && (localStorage.getItem('ReportType_Method') != 'None')) {
        if (data.tarDetails) {
          data.tarDetails.annualReport_Status = event.value
          this.tarDetails = data.tarDetails
        }
      } else {
      }
      this.showValidation1 = false
      this.showValidation2 = false
      this.showValidation3 = false
      this.showValidation4 = false
      this.showValidation5 = false
      this.showValidation6 = false
      this.showValidation7 = false
      this.showValidation8 = false
      this.showValidation9 = false
      this.showValidation10 = false
      this.showValidation11 = false
      this.showValidation12 = false
      this.showValidation13 = false
      this.showValidation14 = false
      this.showValidation16 = false
    })
  }
  type: any
  previousValidHtml: any
  constructor(private configService: ConfigurationService, private router: Router, private sharedService: CharityDataShareServiceService, public Charities_Service: CharitiesService, private apiservice: TarapiService, private datashare: NotesDatashareService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private breakpointObserver: BreakpointObserver,
    private _UsermanagementService: UsermanagementService, private cd: ChangeDetectorRef, private msgService: MessageServiceService, public dialog: MatDialog, private dataShareService: CharityDataShareServiceService) {
    this.ReportType_Method = localStorage.getItem('ReportType_Method')
    this.GetUserAccess()
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }
  ngOnInit(): void {
    this.SubmissionStatus = localStorage.getItem('SubmissionStatus');
    this.sharedService.ReportTypeMethod$.subscribe(value => {
      this.isIndependentExaminer = value === 'Independent Examiner' || value === 'None';
      this.auditor = value === 'Auditor'
      this.type = value;
      if (this.isIndependentExaminer) {
        this.tarDetails.annualReport_Status = 'No';
        this.statementofTrusteesModal.includeTAR = 'No';
      }
    });
    this.Getbasicinformation();
    this.GetCharityDetails();
    this.GetTrusteeData();
    this.GetTar();
    this.CreateCharityTrusteesForm()
  }
  UserRoleAccess: RolesModel;
  GetUserAccess() {
    this.ShowSpinner = true;
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      if (data.entity.length) {
        this.ShowSpinner = false;
        this.UserRoleAccess = data.entity[0]
        var submitedDate = this.UserRoleAccess.currentAPSubmitDate
      }
      this.sharedService.finalStatus$.subscribe((value: any) => {
        this.apFinalised = value !== '' && value === 'Completed';
      });
    });
  }
  charityInformation: any = {
    charityID: 0,
    charity_Name: "",
    other_Names: "",
    charity_Registration_Number: "",
    company_Reference_Number: "",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    addressLine4: "",
    city: "",
    county: "",
    country: "",
    postcode: "",
    startDate: "",
    endDate: ""
  }
  optionalAdvisers: any[] = [
  ]
  otherTrustees: any[] = [
  ]
  tarDetails: any = {
    taR_Id: 0,
    annualReport_Status: "Yes",
    nameofChiefExecutive: "",
    //approvedbyTrustee_SecA: null,
    //approvalDate_SecA: null,
    //description_SecB: "",
    //description_SecB_2: "",
    //description_SecB_3: "",
    //approvedbyTrustee_SecB: "",
    //approvalDate_SecB: null,
    //description_SecC: "",
    //description_SecC_2: "",
    //description_SecC_3: "",
    //description_SecC_4: "",
    //approvedbyTrustee_SecC: "",
    //approvalDate_SecC: null,
    //description_SecD: "",
    //description_SecFS: "",
    //approvedbyTrustee_SecD: "",
    //approvalDate_SecD: null,
    //description_SecE: "",
    //description_SecE_2: "",
    //description_SecE_3: null,
    //description_SecE_4: "",
    //description_SecE_5: null,
    //description_SecE_6: "",
    //description_SecE_S7: "",
    //approvedbyTrustee_SecE: "",
    //approvalDate_SecE: null,
    //description_SecF: "",
    //approvedbyTrustee_SecF: "",
    //approvalDate_SecF: null,
    rowmsg: null,
    charityID: 0,
    createdDate: null,
    createdby: 1,
    modifiedby: 1,
    modifiedDate: null,
    centralUserId: 1,
    userId: 1
  }
  trustees: any = [
  ]
  advisorDetails: any = []
  ngOnDestroy(): void {
  }
  tinyConfig = {
    base_url: '/assets/tinymce',
    suffix: '.min',
    height: 300,
    menubar: false,
    branding: false,
    statusbar: false,
    plugins: 'paste image lists link code table advlist',
    toolbar: `
    undo redo |
    formatselect |
    bold italic underline |
    fontsize |
    forecolor backcolor |
    alignleft aligncenter alignright |
    bullist numlist |
    customImage
`,
    paste_as_text: false,
    paste_data_images: true,
    automatic_uploads: true,
    contextmenu: false,
    entity_encoding: 'raw',
    link_context_toolbar: false,
    setup: (editor: any) => {
      const MAX_WIDTH = 700;
      editor.ui.registry.addButton('customImage', {
        icon: 'Image',
        tooltip: 'Upload Image',
        onAction: () => {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';
          input.onchange = async (e: any) => {
            const file = e.target.files[0];
            if (!file) {
              return;
            }
            const extension = file.name.split('.').pop()?.toLowerCase();
            const allowedExtensions = ['png', 'jpg', 'jpeg'];
            if (!allowedExtensions.includes(extension || '')) {
              Swal.fire({
                html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">File format not supported.</h5> <p class= "f-s-14 p-0 m-t-6 f-w-400 text-black" >The selected file must be in PNG or JPG format.</p>',
                iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
                confirmButtonText: 'OK',
                allowOutsideClick: false
              });
              return;
            }
            try {
              const formData = new FormData();
              formData.append('file', file);
              const response = await fetch(`${this.apiUrl}/TAR/UploadImage`,
                {
                  method: 'POST',
                  body: formData
                }
              );
              const result = await response.json();
              const imageUrl = result.location;
              editor.insertContent(`<img src="${imageUrl}" style="margin:10px;"/>`);
            } catch (error) {
              console.error('Image upload failed', error);
            }
          };
          input.click();
        }
      });
      editor.on('keydown', (e: KeyboardEvent) => {
        const text = editor.getContent({ format: 'text' });
        const allowedKeys = [
          'Backspace',
          'Delete',
          'ArrowLeft',
          'ArrowRight',
          'ArrowUp',
          'ArrowDown',
          'Tab',
          'Home',
          'End'
        ];
        const selectedText = editor.selection.getContent({ format: 'text' });
        if (text.length >= this.MAX_LENGTH && selectedText.length === 0 && !allowedKeys.includes(e.key) && !e.ctrlKey && !e.metaKey
        ) {
          e.preventDefault();
        }
      });
      editor.on('paste', (e: any) => {
        const currentText = editor?.getContent({ format: 'text' });
        const imageCount = editor?.getBody()?.querySelectorAll('img').length;
        const currentLength = currentText.length + imageCount;
        const remaining = this.MAX_LENGTH - currentLength;
        if (remaining <= 0) {
          e.preventDefault();
          return;
        }
        const pastedText = e.clipboardData?.getData('text/plain') || '';
        if (pastedText.length > remaining) {
          e.preventDefault();
          editor.insertContent(
            pastedText.substring(0, remaining)
          );
        }
      });
      editor.on('SetContent', (e: any) => {
        const images = editor?.getBody()?.querySelectorAll('img');
        images?.forEach((img: any) => {
          if (!img.hasAttribute('data-resized') && img.width > 700) {
            img?.setAttribute('width', '700');
            img?.setAttribute('height', '550');
            img?.setAttribute('data-resized', 'true');
          }
        });
      });
      editor.on('ObjectResized', (e: any) => {
        if (e.target.nodeName === 'IMG') {
          const img = e.target;
          let width = img.width;
          let height = img.height;
          if (width > MAX_WIDTH) {
            const ratio = height / width;
            width = MAX_WIDTH;
            height = Math.round(MAX_WIDTH * ratio);
            img?.setAttribute('width', width);
            img?.setAttribute('height', height);
          }
        }
      });
      editor.on('PastePostProcess', (e: any) => {
        const images = e.node.querySelectorAll('img');
        images.forEach((img: any) => {
          if (img.width > 700) {
            img?.setAttribute('width', '700');
            img?.setAttribute('height', '550');
          }
        });
      });
    },
    paste_preprocess: (plugin: any, args: any) => {
      const div = document.createElement('div');
      div.innerHTML = args.content;
      const hasImage = div.querySelector('img');
      if (!hasImage) {
        args.content = div.innerText;
      }
    },
    images_upload_handler: (blobInfo: any) => {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());
        const url = `${this.apiUrl}/TAR/UploadImage`;
        fetch(url, { method: 'POST', body: formData }).then(res => res.json()).then(result => { resolve(result.location); }).catch(() => reject('Upload failed'));
      });
    },
    file_picker_callback: (callback: any) => {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.onchange = (e: any) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = () => {
          callback(reader.result, {
            style: 'margin:10px;'
          });
        };
        reader.readAsDataURL(file);
      };
      input.click();
    },
    image_caption: false,
    image_advtab: false,
    image_dimensions: false
  };
  AddRow() {
    debugger
    var len = this.otherTrustees.length
    const lastDataIndex = len - 1;
    const lastDataRow = this.otherTrustees[lastDataIndex];
    if (lastDataRow?.trustee_Name.trim() !== '') {
      var newRow = {
        otherTrustees_Id: 0,
        trustee_Name: "",
        dateActed: null,
        dateActedResigned: null,
        rowmsg1: null,
        rowmsg2: null,
        charityID: 0,
        createdDate: null,
        createdby: 1,
        modifiedby: 1,
        modifiedDate: null,
        centralUserId: 1,
        userId: 1
      }
      this.otherTrustees = [...(this.otherTrustees || []), newRow]
      this.showValidation1 = false;
    }
    else {
      this.showValidation1 = true;
    }
  }
  DeleteRow(index?: any) {
    if (index !== -1) {
      const updated = [...this.otherTrustees];
      updated.splice(index, 1);
      this.otherTrustees = updated;
    }
  }
  checkoptionaladvisor(): boolean {
    let res = false
    let res1 = false
    this.optionalAdvisers.forEach((item: any) => {
      if (item.typeOfAdviser == "") {
        res = true
      }
      if (item.advisers_Name == "" && item.typeOfAdviser != "") {
        res1 = true
      }
    })
    this.showValidation2 = res
    this.showValidation16 = res1
    return !res && !res1
  }
  checkoptionaladvisor1(): boolean {
    let res = false
    this.optionalAdvisers.forEach((item: any) => {
      if (item.advisers_Name == "" || item.advisers_Name == "") {
        res = true
      }
    })
    return !res
  }
  checkothertrustee(): boolean {
    let res = false
    this.otherTrustees.forEach((item: any) => {
      if (item.trustee_Name == "") {
        res = true
      }
    })
    this.showValidation1 = res
    return !res
  }
  checkothertrustee1(): boolean {
    let res = false
    this.otherTrustees.forEach((item: any) => {
      if (item.trustee_Name == "") {
        res = true
      }
    })
    return !res
  }
  AddRow2() {
    debugger
    var len = this.optionalAdvisers.length
    const lastDataIndex = len - 1;
    const lastDataRow = this.optionalAdvisers[lastDataIndex];
    if (lastDataRow?.typeOfAdviser?.trim() !== '' && lastDataRow?.advisers_Name?.trim() !== '') {
      var newRow = {
        optionalAdvisers_Id: 0,
        advisorsId: 0,
        typeOfAdviser: "",
        advisers_Name: "",
        address: "",
        charityID: 0,
        createdDate: null,
        createdby: 1,
        modifiedby: 1,
        modifiedDate: null,
        centralUserId: 1,
        userId: 1
      }
      this.optionalAdvisers = [...(this.optionalAdvisers || []), newRow]
      this.showValidation2 = false
      this.showValidation16 = false
    }
    else {
      if (lastDataRow?.typeOfAdviser.trim() === '') {
        this.showValidation2 = true;
      }
      if (lastDataRow?.advisers_Name.trim() === '') {
        this.showValidation16 = true;
      }
    }
  }
  DeleteRow2(index?: any) {
    if (index !== -1) {
      const updated = [...this.optionalAdvisers];
      updated.splice(index, 1);
      this.optionalAdvisers = updated;
    }
  }
  displayedColumns: string[] = ['Trustee Name', 'Office', 'DateAppointed', 'DateResigned', 'Name'];
  displayedColumnsOthertrustees: string[] = ['Name', 'DateAppointed', 'DateResigned', 'action'];
  displayedColumnsadvisers: string[] = ['Type of adviser', 'Name', 'Address', 'action'];
  advisers: any[] = [
    { type: 'data', Name: 'Richard Bell', Date: '', },
  ];
  GetTar() {
    var charityid = localStorage.getItem('currentCharityID')
    var fid = localStorage.getItem('currentPeriod')
    this.apiservice.GetTAR(fid).subscribe((data: any) => {
      debugger
      if (data.otherTrustees) {
        this.otherTrustees = data.otherTrustees
      }
      if (data.optionalAdvisers?.length > 0) {
        this.optionalAdvisers = data.optionalAdvisers
      }
      if (data.trustees) {
        this.trustees = data.trustees
      }
      if (data.charityInformation) {
        this.charityInformation = data.charityInformation
        this.startDate = moment(this.charityInformation.startDate)
        this.endDate = moment(this.charityInformation.endDate)
      }
      if (data.tarDetails) {
        if ((localStorage.getItem('ReportType_Method') != 'Independent Examiner') && (localStorage.getItem('ReportType_Method') != 'None')) {
          this.tarDetails = data.tarDetails
          this.initialContent1 = data.tarDetails?.description_SecB
          this.initialContent2 = data.tarDetails?.description_SecC
          this.initialContent3 = data.tarDetails?.description_SecD
          this.initialContent4 = data.tarDetails?.description_SecE
          this.initialContent5 = data.tarDetails?.description_SecF
          this.initialContent6 = data.tarDetails?.description_SecB_2
          this.initialContent7 = data.tarDetails?.description_SecB_3
          this.initialContent8 = data.tarDetails?.description_SecC_2
          this.initialContent9 = data.tarDetails?.description_SecC_3
          this.initialContent10 = data.tarDetails?.description_SecC_4
          this.initialContent11 = data.tarDetails?.description_SecE_2
          this.initialContent13 = data.tarDetails?.description_SecE_4
          this.initialContent15 = data.tarDetails?.description_SecE_6
          this.initialContent17 = data.tarDetails?.description_SecE_S7
          this.initialContent18 = data.tarDetails?.description_SecFS
          if (this.trustees.some((person: any) => person.truste_Id === this.tarDetails.approvedbyTrustee_SecA)) {
          }
          else {
            this.tarDetails.approvedbyTrustee_SecA = null
          }
        } else {
          debugger
          if (data.tarDetails) {
            this.tarDetails = data.tarDetails;
            if (this.tarDetails.annualReport_Status === 'No') {
              this.clearTARData();
            }
            else {
              this.tarDetails = data.tarDetails;
              this.initialContent1 = data.tarDetails?.description_SecB;
              this.initialContent2 = data.tarDetails?.description_SecC;
              this.initialContent3 = data.tarDetails?.description_SecD;
              this.initialContent4 = data.tarDetails?.description_SecE;
              this.initialContent5 = data.tarDetails?.description_SecF;
              this.initialContent6 = data.tarDetails?.description_SecB_2;
              this.initialContent7 = data.tarDetails?.description_SecB_3;
              this.initialContent8 = data.tarDetails?.description_SecC_2;
              this.initialContent9 = data.tarDetails?.description_SecC_3;
              this.initialContent10 = data.tarDetails?.description_SecC_4;
              this.initialContent11 = data.tarDetails?.description_SecE_2;
              this.initialContent13 = data.tarDetails?.description_SecE_4;
              this.initialContent15 = data.tarDetails?.description_SecE_6;
              this.initialContent17 = data.tarDetails?.description_SecE_S7;
              this.initialContent18 = data.tarDetails?.description_SecFS;
            }
          }
        }
      }
      if (data.statementofTrusteesModal) {
        debugger
        this.statementofTrusteesModal = data.statementofTrusteesModal
        const auditType = localStorage.getItem('AuditedType_Method');
        if (this.CharityDetails[0]?.jurisdiction_Charity === 'scotland' && (auditType === 'CompaniesAct2006' || auditType === 'CharitiesandTrusteeInvestmentAct2005')) {
          this.statementofTrusteesModal.trusteeStatement = this.MaindeFaultStatement;
          this.initialContent16 = this.MaindeFaultStatement;
        }
        this.tarDetails.approvalDate_SecA = this.statementofTrusteesModal.approvalDate
        this.tarDetails.approvedbyTrustee_SecA = this.statementofTrusteesModal.trusteeName
        this.selectedTrusteeId = this.statementofTrusteesModal.trusteeName
        if (this.trustees.some((person: any) => person.truste_Id === this.statementofTrusteesModal.trusteeName)) {
        }
      }
      if (data.advisorDetails) {
        this.advisorDetails = data.advisorDetails
      }
    })
  }
  isLastDataRow1(index: number): boolean {
    var f1 = this.otherTrustees.length ? this.otherTrustees.length : 0
    const footerIndex = f1 - 1
    if (footerIndex >= 0) {
      return index === footerIndex;
    }
    return false;
  }
  isLastDataRow2(index: number): boolean {
    var f1 = this.optionalAdvisers.length ? this.optionalAdvisers.length : 0
    const footerIndex = f1 - 1
    if (footerIndex >= 0) {
      return index === footerIndex;
    }
    return false;
  }
  allTrustees: string[] = [];
  SaveTar() {
    debugger
    if (this.apFinalised) {
      this.isdirty = false;
      this.datashare.setisdirty(false);
      if (this.type == 'Independent Examiner') {
        this.router.navigate(['independentexaminerreport']);
      } else if (this.type == "Auditor") {
        this.router.navigate(['audit-report']);
      }
      else {
        this.router.navigate(['final-accounts']);
      }
    }
    else if (!this.isDeclarationDisabled() && (!this.isSectionGValid() || this.tarDetails.rowmsg)) {
      return;
    }
    else {
      if (this.tarDetails.annualReport_Status == 'Yes') {
        const isEmpty = (html: any) =>
          !this.stripHtmlTags(html || '').trim();

        const fieldsToValidate = [...descriptionFields];

        if (this.jurisdiction_Charity === 'scotland') {
          fieldsToValidate.push('description_SecE_S7');
        }
        const isEmptyReport = fieldsToValidate.every(
          field => isEmpty(this.tarDetails[field])
        );

        if (isEmptyReport) {
          const sectionRange = this.jurisdiction_Charity === 'scotland' ? 'B to F' : 'B to E';

          Swal.fire({
            html: `<p class="f-s-14 p-0 f-w-400 text-black"> At least one section from ${sectionRange} of the Trustees Annual Report must be completed before proceeding.</p> `,
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: 'OK',
            showCancelButton: false,
            allowOutsideClick: false
          });
          return;
        }
      }
      var charityid = localStorage.getItem('currentCharityID')
      var uid = localStorage.getItem('CurrentuserID')
      var cid = localStorage.getItem('CentralUserId')
      var fid = localStorage.getItem('currentPeriod')
      this.tarDetails.charityID = charityid ? +charityid : 0
      this.tarDetails.userId = uid ? +uid : 0
      this.tarDetails.centralUserId = cid ? +cid : 0
      this.tarDetails.createdby = uid ? +uid : 0
      this.tarDetails.modifiedby = uid ? +uid : 0
      this.tarDetails.financialPeriodsID = fid ? +fid : 0
      this.tarDetails.approvalDate_SecA = this.tarDetails.approvalDate_SecA ? moment(this.tarDetails.approvalDate_SecA).format('YYYY-MM-DD') : null
      this.statementofTrusteesModal.approvalDate = this.tarDetails.approvalDate_SecA
      this.statementofTrusteesModal.trusteeName = this.tarDetails.approvedbyTrustee_SecA
      if (this.statementofTrusteesModal.includeTAR == "No") {
        this.statementofTrusteesModal.trusteeStatement = this.MaindeFaultStatement
      }
      this.statementofTrusteesModal.charityID = charityid ? +charityid : 0
      this.statementofTrusteesModal.userId = uid ? +uid : 0
      this.statementofTrusteesModal.modifiedby = uid ? +uid : 0
      this.statementofTrusteesModal.centralUserId = cid ? +cid : 0
      this.statementofTrusteesModal.createdby = uid ? +uid : 0
      this.statementofTrusteesModal.financialPeriodsID = fid ? +fid : 0
      this.otherTrustees.forEach((item: any) => {
        item.dateActed = item.dateActed ? moment(item.dateActed).format('YYYY-MM-DD') : null
        item.dateActedResigned = item.dateActedResigned ? moment(item.dateActedResigned).format('YYYY-MM-DD') : null
      })
      this.trustees.forEach((item: any) => {
        item.datesActed = item.datesActed ? moment(item.datesActed).format('YYYY-MM-DD') : null
        item.dateActedResigned = item.dateActedResigned ? moment(item.dateActedResigned).format('YYYY-MM-DD') : null
      })
      if (this.tarDetails.annualReport_Status === 'No') {
      }
      if (this.statementofTrusteesModal.includeTAR === 'No') {
        this.clearStatementData();
      }
      if (this.isDeclarationDisabled()) {
        this.resetDeclarationUI();
      }
      const payload = {
        charityInformation: this.charityInformation,
        trustees: this.trustees,
        optionalAdvisers: this.optionalAdvisers,
        otherTrustees: this.otherTrustees,
        tarDetails: this.tarDetails,
        statementofTrusteesModal: this.statementofTrusteesModal
      }
      this.apiservice.saveTAR(payload).subscribe((Data) => {
        debugger
        this.isdirty = false
        this.datashare.setisdirty(false)
        if (this.type == "Independent Examiner") {
          this.router.navigate(['independentexaminerreport']);
        } else if (this.type == "Auditor") {
          this.router.navigate(['audit-report']);
        }
        else {
          this.router.navigate(['final-accounts']);
        }
      })
    }
  }
  selectedTabIndex = 0;
  canNavigateToTab(index: number): boolean {
    if (index === 1 && !this.isSectionAValid()) {
      return false;
    }
    if (index === 7 && !this.isSectionGValid()) {
      return false;
    }
    return true;
  }
  isSectionAValid(): boolean {
    this.checkothertrustee();
    this.checkoptionaladvisor();
    return this.checkothertrustee() && this.checkoptionaladvisor()
  }
  isSectionAValid1(): boolean {
    this.checkothertrustee1();
    this.checkoptionaladvisor1();
    return this.checkothertrustee1() && this.checkoptionaladvisor1()
  }
  isSectionGValid(): boolean {
    if (this.isDeclarationDisabled()) {
      return true;
    }
    this.showValidation3 = this.tarDetails.approvedbyTrustee_SecA == null;
    this.showValidation4 = this.tarDetails.approvalDate_SecA == null;
    return !!(
      this.tarDetails.approvedbyTrustee_SecA &&
      this.tarDetails.approvalDate_SecA
    );
  }
  canOpenDeclaration(): boolean {
    return this.checkothertrustee1() &&
      this.checkoptionaladvisor1();
  }
  canOpenStatementOfRes(): boolean {
    return this.checkothertrustee1() &&
      this.checkoptionaladvisor1();
  }
  isSectionCValid(): boolean {
    this.showValidation7 = this.tarDetails.approvedbyTrustee_SecC == ""
    this.showValidation8 = this.tarDetails.approvalDate_SecC == null
    return this.tarDetails.approvedbyTrustee_SecC && this.tarDetails.approvalDate_SecC
  }
  isSectionDValid(): boolean {
    this.showValidation9 = this.tarDetails.approvedbyTrustee_SecD == ""
    this.showValidation10 = this.tarDetails.approvalDate_SecD == null
    return this.tarDetails.approvedbyTrustee_SecD && this.tarDetails.approvalDate_SecD
  }
  isSectionEValid(): boolean {
    this.showValidation11 = this.tarDetails.approvedbyTrustee_SecE == ""
    this.showValidation12 = this.tarDetails.approvalDate_SecE == null
    return this.tarDetails.approvedbyTrustee_SecE && this.tarDetails.approvalDate_SecE
  }
  isSectionFValid(): boolean {
    this.showValidation13 = this.tarDetails.approvedbyTrustee_SecF == ""
    this.showValidation14 = this.tarDetails.approvalDate_SecF == null
    return this.tarDetails.approvedbyTrustee_SecF && this.tarDetails.approvalDate_SecF
  }
  onTabChange(event: MatTabChangeEvent) {
    const newIndex = event.index;
    this.selectedTabIndex = newIndex;
    if (!this.canNavigateToTab(newIndex)) {
      this.goToPreviousTab()
      return;
    }
  }
  goToNextTab(value: any): void {
    debugger
    if (this.isAnyDateInvalid() && value === 'yes') {
      return
    }
    const nextIndex = this.selectedTabIndex + 1;
    if (value === 'yes') {
      if (this.canNavigateToTab(nextIndex)) {
        const lastTabIndex = this.jurisdiction_Charity === 'scotland' ? 5 : 4;
        if (nextIndex > lastTabIndex) {
          this.showStatementofRes();
        } else {
          this.selectedTabIndex = nextIndex;
        }
      }
    }
    else {
      this.showStatementofRes();
    }
  }
  goToPreviousTab() {
    const prevIndex = this.selectedTabIndex - 1;
    if (prevIndex >= 0) {
      this.selectedTabIndex = prevIndex;
    }
    else {
      this.Back()
    }
  }
  backToCharityOverView() {
    debugger
    localStorage.setItem('isFromBasicInfo', 'true')
    this.router.navigate(['/charity']);
  }
  Back() {
    debugger
    this.router.navigate(['/Accountnotes']);
  }
  next() {
    debugger
    this.router.navigate(['/statementoftrustees'])
  }
  get advisorTypes(): string[] {
    return Array.from(
      new Set(
        this.advisorDetails.map((x: any) => x.professionalAdvisors_Type)
      )
    );
  }
  getAdvisorNamesByType(type: string): any[] {
    return this.advisorDetails.filter((x: any) => x.professionalAdvisors_Type === type);
  }
  onAdvisorNameChange(type: string, name: string, index: number): void {
    debugger
    const matchedAdvisor = this.advisorDetails.find((adv: any) =>
      adv.advisorsId == name
    );
    if (matchedAdvisor) {
      const fullAddress = [
        matchedAdvisor.professionalAdvisors_Address_Line_1,
        matchedAdvisor.professionalAdvisors_Address_Line_2,
        matchedAdvisor.professionalAdvisors_City,
        matchedAdvisor.professionalAdvisors_Postcode
      ]
        .filter(Boolean)
        .join(', ');
      this.optionalAdvisers[index].address = fullAddress;
      this.optionalAdvisers[index].advisers_Name = matchedAdvisor.professionalAdvisors_Name;
    } else {
      this.optionalAdvisers[index].address = '';
    }
  }
  isDateInvalid(dateString: string): boolean {
    if (!dateString) return false;
    const date = new Date(dateString);
    var res1 = date < this.startDate
    var res2 = date > this.endDate
    return res1 || res2;
  }
  isDatesActedResignedValid(datesActed: string, datesActedResigned: string): boolean {
    if (!datesActed || !datesActedResigned) return true;
    const acted = new Date(datesActed);
    const resigned = new Date(datesActedResigned);
    var res = resigned >= acted
    return res;
  }
  isAnyDateInvalid(): boolean {
    const trusteesInvalid = this.trustees.some((trustee: any) =>
      !this.isDatesActedResignedValid(trustee.datesActed, trustee.dateActedResigned) ||
      trustee.rowmsg1 ||
      trustee.rowmsg2
    );
    const otherTrusteesInvalid = this.otherTrustees.some(trustee =>
      this.isDateInvalid(trustee.datesActed) ||
      this.isDateInvalid(trustee.dateActedResigned) ||
      !this.isDatesActedResignedValid(trustee.datesActed, trustee.dateActedResigned) ||
      trustee.rowmsg1 ||
      trustee.rowmsg2
    );
    return trusteesInvalid || otherTrusteesInvalid;
  }
  MAX_LENGTH = 2500;
  trim(html: string, name: any): void {
    this.updateTarDetails(name, html);
  }
  handleEditorInput(html: string, name: any): void {
    const div = document.createElement('div');
    div.innerHTML = html;
    const plainText = div.textContent || '';
    if (name === 'trusteeStatement') {
      this.showValidationStatement = !plainText.trim();
    }
    if (plainText.length <= this.MAX_LENGTH) {
      //this.updateTarDetails(name, html);
      this.markDirty(name, html);
      return;
    }
    const trimmedHtml = this.SethtmlTo2500(html);
    const editor = (window as any).tinymce?.activeEditor;
    if (editor) {
      editor.setContent(trimmedHtml);
      //editor.selection.select(editor.getBody(), true);
      //editor.selection.collapse(false);
    }
    this.updateTarDetails(name, trimmedHtml);
    this.markDirty(name, trimmedHtml);
  }
  SethtmlTo2500(html: string): string {
    debugger
    var maxLength: number = 2500
    const div = document.createElement('div');
    div.innerHTML = html;
    let charCount = 0;
    const walker = document.createTreeWalker(div, NodeFilter.SHOW_TEXT, null);
    const nodesToRemove: Node[] = [];
    while (walker.nextNode()) {
      const node = walker.currentNode as Text;
      const remaining = maxLength - charCount;
      if (remaining <= 0) {
        nodesToRemove.push(node);
      } else if (node.nodeValue!.length > remaining) {
        node.nodeValue = node.nodeValue!.substring(0, remaining);
        charCount = maxLength;
      } else {
        charCount += node.nodeValue!.length;
      }
    }
    nodesToRemove.forEach(node => node.parentNode?.removeChild(node));
    const cleanEmptyElements = (element: HTMLElement) => {
      Array.from(element.children).forEach(child => {
        cleanEmptyElements(child as HTMLElement);
        if (
          child.childNodes.length === 0 ||
          (child.childNodes.length === 1 && child.childNodes[0].nodeType === Node.TEXT_NODE && !(child.textContent || '').trim())
        ) {
          child.remove();
        }
      });
    };
    cleanEmptyElements(div);
    return div.innerHTML;
  }
  updateTarDetails(name: string, html: string) {
    debugger
    html = this.altchange(html);
    switch (name) {
      case 'description_SecB':
        this.tarDetails.description_SecB = html;
        break;
      case 'description_SecB_2':
        this.tarDetails.description_SecB_2 = html;
        break;
      case 'description_SecB_3':
        this.tarDetails.description_SecB_3 = html;
        break;
      case 'description_SecC':
        this.tarDetails.description_SecC = html;
        break;
      case 'description_SecC_2':
        this.tarDetails.description_SecC_2 = html;
        break;
      case 'description_SecC_3':
        this.tarDetails.description_SecC_3 = html;
        break;
      case 'description_SecC_4':
        this.tarDetails.description_SecC_4 = html;
        break;
      case 'description_SecD':
        this.tarDetails.description_SecD = html;
        break;
      case 'description_SecE':
        this.tarDetails.description_SecE = html;
        break;
      case 'description_SecE_2':
        this.tarDetails.description_SecE_2 = html;
        break;
      case 'description_SecE_4':
        this.tarDetails.description_SecE_4 = html;
        break;
      case 'description_SecE_6':
        this.tarDetails.description_SecE_6 = html;
        break;
      case 'description_SecE_S7':
        this.tarDetails.description_SecE_S7 = html;
        break;
      case 'description_SecFS':
        this.tarDetails.description_SecFS = html;
        break;
      case 'trusteeStatement':
        this.statementofTrusteesModal.trusteeStatement = html
        break;
    }
  }
  stripHtmlTags(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }
  plainTextToHtmlWithSpaces(text: string): string {
    return text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/  /g, " &nbsp;")
      .replace(/\n/g, "<br>");
  }
  isValidDate(date: any): boolean {
    if (!date) return false;
    if (typeof date === 'string') {
      date = new Date(date);
    }
    return date instanceof Date && !isNaN(date.getTime());
  }
  checkdate(event: any, row: any) {
    debugger
    const baseDate = moment('01/01/1753', 'DD/MM/YYYY');
    const compareDate = moment(event.target.value, 'DD/MM/YYYY');
    if (!event.target.value || (moment(event.target.value, 'DD/MM/YYYY', true).isValid() && compareDate.isBefore(baseDate))) {
      row.rowmsg = null
      return
    }
    if (moment(event.target.value, 'DD/MM/YYYY', true).isValid()) {
      row.rowmsg = null
      if (compareDate < this.startDate || compareDate > this.today) {
        row.rowmsg = "Approval Date should be on or between Accounting Period Start and Today's Date"
      }
    }
    else {
      row.rowmsg = 'Approval Date is invalid'
    }
  }
  checkdate4(event: any, row: any) {
    debugger
    const baseDate = moment('01/01/1753', 'DD/MM/YYYY');
    const compareDate = moment(event.target.value, 'DD/MM/YYYY');
    if (!event.target.value || (moment(event.target.value, 'DD/MM/YYYY', true).isValid() && compareDate.isBefore(baseDate))) {
      row.rowmsg2 = null
      return
    }
    if (moment(event.target.value, 'DD/MM/YYYY', true).isValid()) {
      row.rowmsg2 = null
      if (compareDate < this.startDate || compareDate > this.endDate) {
        row.rowmsg2 = 'Date Resigned should be on or between Accounting Period Start and End Date'
      }
      else if (row.datesActed) {
        if (new Date(row.dateActedResigned) < new Date(row.datesActed)) {
          if (row.rowmsg1 == 'Date Appointed must be on or before Date Resigned') {
            row.rowmsg2 = null
          }
          else {
            row.rowmsg2 = 'Date Resigned must be on or after Date Appointed'
          }
        }
        else {
          row.rowmsg2 = null
        }
      }
      else {
        row.rowmsg2 = null
      }
    }
    else {
      row.rowmsg2 = 'Date Resigned is invalid'
    }
  }
  checkdate3(event: any, row: any) {
    debugger
    const baseDate = moment('01/01/1753', 'DD/MM/YYYY');
    const compareDate = moment(event.target.value, 'DD/MM/YYYY');
    if (!event.target.value || (moment(event.target.value, 'DD/MM/YYYY', true).isValid() && compareDate.isBefore(baseDate))) {
      row.rowmsg1 = null
      return
    }
    if (moment(event.target.value, 'DD/MM/YYYY', true).isValid()) {
      row.rowmsg1 = null
      if (compareDate < this.startDate || compareDate > this.endDate) {
        row.rowmsg1 = 'Date Appointed should be on or between Accounting Period Start and End Date'
      }
      else if (row.dateActedResigned) {
        if (new Date(row.datesActed) > new Date(row.dateActedResigned)) {
          if (row.rowmsg2 == 'Date Resigned must be on or after Date Appointed') {
            row.rowmsg1 = null
          }
          else {
            row.rowmsg1 = 'Date Appointed must be on or before Date Resigned'
          }
        }
        else {
          row.rowmsg1 = null
          // row.rowmsg2 = null
        }
      }
      else {
        row.rowmsg1 = null
      }
    }
    else {
      row.rowmsg1 = 'Date Appointed is invalid'
    }
  }
  checkdate2(event: any, row: any) {
    debugger
    const baseDate = moment('01/01/1753', 'DD/MM/YYYY');
    const compareDate = moment(event.target.value, 'DD/MM/YYYY');
    if (!event.target.value || (moment(event.target.value, 'DD/MM/YYYY', true).isValid() && compareDate.isBefore(baseDate))) {
      row.rowmsg2 = null
      return
    }
    if (moment(event.target.value, 'DD/MM/YYYY', true).isValid()) {
      row.rowmsg2 = null
      if (compareDate < this.startDate || compareDate > this.endDate) {
        row.rowmsg2 = 'Date Resigned should be on or between Accounting Period Start and End Date'
      }
      else if (row.dateActed) {
        if (new Date(row.dateActedResigned) < new Date(row.dateActed)) {
          if (row.rowmsg1 == 'Date Appointed must be on or before Date Resigned') {
            row.rowmsg2 = null
          }
          else {
            row.rowmsg2 = 'Date Resigned must be on or after Date Appointed'
          }
        }
        else {
          row.rowmsg2 = null
        }
      }
      else {
        row.rowmsg2 = null
      }
    }
    else {
      row.rowmsg2 = 'Date Resigned is invalid'
    }
  }
  checkdate1(event: any, row: any) {
    debugger
    const baseDate = moment('01/01/1753', 'DD/MM/YYYY');
    const compareDate = moment(event.target.value, 'DD/MM/YYYY');
    if (!event.target.value || (moment(event.target.value, 'DD/MM/YYYY', true).isValid() && compareDate.isBefore(baseDate))) {
      row.rowmsg1 = null
      return
    }
    if (moment(event.target.value, 'DD/MM/YYYY', true).isValid()) {
      row.rowmsg1 = null
      if (compareDate < this.startDate || compareDate > this.endDate) {
        row.rowmsg1 = 'Date Appointed should be on or between Accounting Period Start and End Date'
      }
      else if (row.dateActedResigned) {
        if (new Date(row.dateActed) > new Date(row.dateActedResigned)) {
          if (row.rowmsg2 == 'Date Resigned must be on or after Date Appointed') {
            row.rowmsg1 = null
          }
          else {
            row.rowmsg1 = 'Date Appointed must be on or before Date Resigned'
          }
        }
        else {
          row.rowmsg1 = null
        }
      }
      else {
        row.rowmsg1 = null
      }
    }
    else {
      row.rowmsg1 = 'Date Appointed is invalid'
      return
    }
  }
  removevalid1(event: any, row: any) {
    debugger
    if (!event.target.value) {
      row.rowmsg1 = null
      if (row.rowmsg2 == 'Date Resigned must be on or after Date Appointed') {
        row.rowmsg2 = null
      }
      return
    }
  }
  removevalid2(event: any, row: any) {
    debugger
    if (!event.target.value) {
      row.rowmsg2 = null
      if (row.rowmsg1 == 'Date Appointed must be on or before Date Resigned') {
        row.rowmsg1 = null
      }
      return
    }
  }
  removevalid3(event: any, row: any) {
    debugger
    if (!event.target.value) {
      row.rowmsg1 = null
      if (row.rowmsg2 == 'Date Resigned must be on or after Date Appointed') {
        row.rowmsg2 = null
      }
      return
    }
  }
  removevalid4(event: any, row: any) {
    debugger
    if (!event.target.value) {
      row.rowmsg2 = null
      if (row.rowmsg1 == 'Date Appointed must be on or before Date Resigned') {
        row.rowmsg1 = null
      }
      return
    }
  }
  removevalid(event: any, row: any) {
    if (!event.target.value) {
      row.rowmsg = null
      return
    }
  }
  isdirty: boolean = false
  CharityTrusteesFrom: FormGroup
  dirty() {
    this.isdirty = true
    this.datashare.setisdirty(true)
  }
  CanDeactivate(): any {
    debugger
    if (this.isdirty) {
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          debugger
          this.isdirty = false;
          this.datashare.setisdirty(false)
          return true
        } else {
          localStorage.setItem("currentCharityIDFromSwitch", "");
          return false
        }
      })
    } else {
      return true
    }
  }
  //---------------------------code for statement of responsibility------------------------------------
  setVisibility1(event: MatRadioChange) {
    debugger;
    const value = event.value;
    const fid = localStorage.getItem('currentPeriod');
    this.statementofTrusteesModal.includeTAR = value;
    if (value === 'No') {
      //this.tarDetails.approvedbyTrustee_SecA = null;
      //this.tarDetails.approvalDate_SecA = null;
      this.tarDetails.rowmsg = null;
      this.showValidation3 = false;
      this.showValidation4 = false;
      this.statementofTrusteesModal.trusteeStatement = this.MaindeFaultStatement;
      const editor = (window as any).tinymce?.activeEditor;
      if (editor) {
        editor.setContent(this.MaindeFaultStatement);
      }
      return;
    }
    this.apiservice.GetTAR(fid).subscribe((data: any) => {
      this.statementofTrusteesModal = {
        trusteeStatementID: 0,
        includeTAR: value,
        trusteeStatement: "",
        trusteeName: this.statementofTrusteesModal?.trusteeName ?? null,
        approvalDate: this.statementofTrusteesModal?.approvalDate ?? null,
        charityID: 0,
        createdDate: null,
        createdby: 1,
        modifiedby: 1,
        modifiedDate: null,
        centralUserId: 1,
        userId: 1,
        financialPeriodsID: 0
      };
      if (data?.statementofTrusteesModal) {
        data.statementofTrusteesModal.includeTAR = value;
        this.statementofTrusteesModal = data.statementofTrusteesModal;
        this.initialContent16 = data.statementofTrusteesModal.trusteeStatement;
        const editor = (window as any).tinymce?.activeEditor;
        if (editor) {
          editor.setContent(this.statementofTrusteesModal?.trusteeStatement);
        }
      }
      else {
        this.statementofTrusteesModal.trusteeStatement = this.MaindeFaultStatement;
        const editor = (window as any).tinymce?.activeEditor;
        if (editor) {
          editor.setContent(this.statementofTrusteesModal?.trusteeStatement);
        }
      }
    });
  }
  CountryACT: any = ''
  CountryName: string;
  MaindeFaultStatement: string;
  deFaultStatement: string
  CharityDetails: CharityDetailsModal[];
  statementofTrusteesModal = {
    trusteeStatementID: 0,
    includeTAR: "No",
    trusteeStatement: "",
    trusteeName: null,
    approvalDate: null,
    charityID: 0,
    createdDate: null,
    createdby: 1,
    modifiedby: 1,
    modifiedDate: null,
    centralUserId: 1,
    userId: 1,
    financialPeriodsID: 0
  }
  jurisdiction_Charity: any = '';
  Basicinfodata: any;
  Getbasicinformation() {
    debugger
    var Id = localStorage.getItem("SwitchcurrentPeriod")
    if (localStorage.getItem("currentPeriod") != localStorage.getItem("SwitchcurrentPeriod") && Id != null && Id != '') {
      localStorage.setItem("currentPeriod", Id != null && Id != '' ? Id : '')
      localStorage.setItem("SwitchcurrentPeriod", '')
    }
    const period = localStorage.getItem('currentPeriod');
    const charityId = localStorage.getItem('currentCharityID');
    this.Charities_Service.Getbasicinfo(charityId, period).subscribe((data: any) => {
      debugger
      localStorage.setItem('ReportType_Method', data[0].report_Type);
      localStorage.setItem('AuditedType_Method', data[0].audited_Type);
    })
  }

  GetCharityDetails() {
    debugger
    var charityID = localStorage.getItem('currentCharityID') != '' ? localStorage.getItem('currentCharityID') : 0
    this.Charities_Service.EditCharityDetails(charityID).subscribe((data: CharityDetailsModal[]) => {
      debugger
      this.CharityDetails = data;
      this.jurisdiction_Charity = this.CharityDetails[0]?.jurisdiction_Charity;
      const auditType = localStorage.getItem('AuditedType_Method');
      const ReportType = localStorage.getItem('ReportType_Method');
      //if (data[0].charity_Type == 'Unincorporated Charity') {
        if (this.CharityDetails[0].jurisdiction_Charity == "england_wales") {
          this.CountryACT = `the Charity (Accounts and Reports) Regulations 2008`
          this.CountryName = 'England and Wales'
        }
        else if (this.CharityDetails[0].jurisdiction_Charity == "scotland") {
          this.CountryACT = `the Charities and Trustee Investment (Scotland) Act 2005 and the Charities Accounts (Scotland) Regulations 2006`
          this.CountryName = 'Scotland'
        }
        else {
          this.CountryACT = `The Charities (Accounts and Reports) Regulations (Northern Ireland) 2015]`
          this.CountryName = 'Northern Ireland'
        }
        this.MaindeFaultStatement = `<p>The trustees are responsible for preparing the Trustees' Annual Report and the financial statements in accordance with applicable law and United Kingdom Accounting Standards (United Kingdom Generally Accepted Accounting Practice).</p>
        <p>The law applicable to charities in ${this.CountryName} requires the trustees to prepare financial statements for each financial year which give a true and fair view of the state of affairs of the charity and of the incoming resources and application of resources of the charity for that period. In preparing these financial statements, the trustees are required to:</p>
         <ul>
            <li>select suitable accounting policies and apply them consistently;</li>
            <li>observe the methods and principles in the Charities SORP;</li>
            <li>make judgments and estimates that are reasonable and prudent;</li>
            <li>state whether applicable accounting standards have been followed, subject to any departures disclosed and explained in the financial statements; and</li>
            <li>prepare the accounts on a going concern basis unless it is inappropriate to presume that the charity will continue in business.</li>
         </ul>
        <p>The trustees are responsible for maintaining proper accounting records which disclose with reasonable accuracy at any time the financial position of the charity and to enable them to ensure that the accounts comply with the Charities Act 2011 ${this.CountryACT} and the provisions of the trust deed. They are also responsible for safeguarding the assets of the charity and hence for taking reasonable steps for the prevention and detection of fraud and other irregularities.</p>`
      //}
     // else {
        if (this.CharityDetails[0].jurisdiction_Charity == "england_wales")
          this.CountryACT = `the accounts comply with the Companies Act 2006`
        else if (this.CharityDetails[0].jurisdiction_Charity == "scotland")
          this.CountryACT = `the Charities and Trustee Investment (Scotland) Act 2005 and the Charities Accounts (Scotland) Regulations 2006]`
        else
          this.CountryACT = ``
        if (this.CharityDetails[0]?.jurisdiction_Charity == 'scotland') {
          this.MaindeFaultStatement = `The Trustees(who are also Directors of ${this.CharityDetails[0].charity_Name} for the purposes of company law) are responsible for preparing the Trustees' Report and the financial statements in accordance with applicable law and United Kingdom Accounting Standards (United Kingdom Generally Accepted Accounting Practice).
         <p>Company Law requires the Trustees to prepare financial statements for each financial year, which give a true and fair view of the state of affairs of the charitable company and of the incoming resources and application of resources, including the income and expenditure, of the charitable company for the year.In preparing these financial statements, the Trustees are required to:</p>
        <ul>
         <li>select suitable accounting policies and then apply them consistently:</li>
         <li>observe the methods and principles in the Charities SORP(FRS102);</li>
         <li>make judgements and estimates that are reasonable and prudent;</li>
         <li>state whether applicable UK Accounting Standards have been followed, subject to any material departures disclosed and explained in the financial statements; and</li>
         <li>prepare the financial statements on the going concern basis unless it is inappropriate to presume that the charitable company will continue in operation.</li>
         </ul>
         <p>The Trustees are responsible for keeping adequate accounting records that disclose with reasonable accuracy at any time the financial position of the charitable company and enable them to ensure that the financial statements comply with the Companies Act 2006, the Charities and Trustee Investment (Scotland) Act 2005 and the Charities Accounts (Scotland) Regulations 2006.</p>
         <p>They are also responsible for safeguarding the assets of the charitable company and hence for taking reasonable steps for the prevention and detection of fraud and other irregularities.</p>
         <p>The Trustees are responsible for the maintenance and integrity of the corporate and financial information included on the charitable company's website.</p>
         <p>Legislation in the United Kingdom governing the preparation and dissemination of financial statements may differ from legislation in other jurisdictions.</p>`
        }
        else if  ((this.CharityDetails[0].jurisdiction_Charity == "england_wales")) {
          this.MaindeFaultStatement = `<p>The trustees are responsible for preparing the Trustees' Annual Report and the financial statements in accordance with applicable law and United Kingdom Accounting Standards (United Kingdom Generally Accepted Accounting Practice).</p>
        <p>The law applicable to charities in ${this.CountryName} requires the trustees to prepare financial statements for each financial year which give a true and fair view of the state of affairs of the charity and of the incoming resources and application of resources of the charity for that period. In preparing these financial statements, the trustees are required to:</p>
         <ul>
            <li>select suitable accounting policies and apply them consistently;</li>
            <li>observe the methods and principles in the Charities SORP;</li>
            <li>make judgments and estimates that are reasonable and prudent;</li>
            <li>state whether applicable accounting standards have been followed, subject to any departures disclosed and explained in the financial statements; and</li>
            <li>prepare the accounts on a going concern basis unless it is inappropriate to presume that the charity will continue in business.</li>
         </ul>
        <p>The trustees are responsible for maintaining proper accounting records which disclose with reasonable accuracy at any time the financial position of the charity and to enable them to ensure that the accounts comply with the Charities Act 2011 ${this.CountryACT} and the provisions of the trust deed. They are also responsible for safeguarding the assets of the charity and hence for taking reasonable steps for the prevention and detection of fraud and other irregularities.</p>`;
        }
      //}
    })
  }
  SetDefault() {
    debugger
    const editor = (window as any).tinymce?.activeEditor;
    if (editor) {
      editor.setContent(this.MaindeFaultStatement);
    }
    this.statementofTrusteesModal.trusteeStatement = this.MaindeFaultStatement;
    this.showValidationStatement = false;

  }
  UnlockandAmend() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Amend) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Unlocking the accounting period will allow you to amend the filed accounts and correct any errors. After making any changes, the accounts must be submitted again as an Amended filing. Do you want to unlock and amend the accounting period?</p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted');
            localStorage.setItem('NewAmendCycle', 'true');
          })
        }
        else { }
      })
    }
    else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"><b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  UnfreezeAP() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Do you want to unlock the Accounting Period? </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            const message = "Accounting Period unlocked successfully";
            this.msgService.showToastMessage('success', message)
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
        }
      })
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  gotoSubmissions() {
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      this._UsermanagementService.GoToSubmissions()
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  isDeclarationDisabled(): boolean {
    return (
      this.tarDetails?.annualReport_Status === 'No' &&
      this.statementofTrusteesModal?.includeTAR === 'No'
    );
  }
  onDecimalInput(event: any, field: string): void {
    let value = event.target.value
      .replace(/[^0-9-]/g, '')
      .replace(/(?!^)-/g, '')
      .replace(/^(-?\d{8})\d+/, '$1')
    event.target.value = value;
    this.tarDetails[field] = Number(value);
  }
  clearDeclarationData() {
    //this.tarDetails.approvedbyTrustee_SecA = null;
    //this.tarDetails.approvalDate_SecA = null;
    this.tarDetails.rowmsg = null;
    this.showValidation3 = false;
    this.showValidation4 = false;
  }
  clearStatementData() {
    this.statementofTrusteesModal.trusteeStatement = this.MaindeFaultStatement;
  }
  clearTARData() {
    //this.tarDetails.description_SecB = '';
    //this.tarDetails.description_SecB_2 = '';
    //this.tarDetails.description_SecB_3 = '';
    //this.tarDetails.description_SecC = '';
    //this.tarDetails.description_SecD = '';
    //this.tarDetails.description_SecFS = '';
    //this.tarDetails.description_SecE = '';
    //this.tarDetails.description_SecB = "";
    //this.tarDetails.description_SecB_2 = "";
    //this.tarDetails.description_SecB_3 = "";
    ////this.tarDetails.approvedbyTrustee_SecB = "";
    ////this.tarDetails.approvalDate_SecB = null;
    //this.tarDetails.description_SecC = "";
    //this.tarDetails.description_SecC_2 = "";
    //this.tarDetails.description_SecC_3 = "";
    //this.tarDetails.description_SecC_4 = "";
    ////this.tarDetails.approvedbyTrustee_SecC = "";
    ////this.tarDetails.approvalDate_SecC = null;
    //this.tarDetails.description_SecD = "";
    //this.tarDetails.description_SecFS = "";
    ////this.tarDetails.approvedbyTrustee_SecD = "";
    ////this.tarDetails.approvalDate_SecD = null;
    //this.tarDetails.description_SecE = "";
    //this.tarDetails.description_SecE_2 = "";
    //this.tarDetails.description_SecE_3 = null;
    //this.tarDetails.description_SecE_4 = "";
    //this.tarDetails.description_SecE_5 = null;
    //this.tarDetails.description_SecE_6 = "";
    //this.tarDetails.description_SecE_S7 = "";
    ////this.tarDetails.approvedbyTrustee_SecE = "";
    ////this.tarDetails.approvalDate_SecE = null;
    //this.tarDetails.description_SecF = "";
    ////this.tarDetails.approvedbyTrustee_SecF = "";
    ////this.tarDetails.approvalDate_SecF = null;
  }
  resetDeclarationUI() {
    this.tarDetails.approvedbyTrustee_SecA = null;
    this.tarDetails.approvalDate_SecA = null;
    this.tarDetails.rowmsg = null;
    this.showValidation3 = false;
    this.showValidation4 = false;
    setTimeout(() => {
      this.tarDetails.approvedbyTrustee_SecA = null;
      this.tarDetails.approvalDate_SecA = null;
    });
  }
  openCropper() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/png, image/jpeg';
    input.onchange = (event: any) => {
      const file = event.target.files[0];
      this.imageFile = file;
      this.showCropper = true;
      console.log("imageChangedEvent:", this.imageFile);
      console.log("showCropper:", this.showCropper);
    };
    input.click();
  }
  imageCropped(event: any) {
    console.log("CROPPED EVENT FULL:", event);
    if (event.base64) {
      this.croppedImage = event.base64;
    } else if (event.objectUrl) {
      this.croppedImage = event.objectUrl;
    } else if (event.blob) {
      const reader = new FileReader();
      reader.onload = () => {
        this.croppedImage = reader.result as string;
        this.cd.detectChanges();
      };
      reader.readAsDataURL(event.blob);
      return;
    }
    this.cd.detectChanges();
  }
  addCroppedImage() {
    if (!this.croppedImage) return;
    if (this._resolveCrop) {
      this._resolveCrop({
        default: this.croppedImage
      });
    }
    this.showCropper = false;
    this.croppedImage = '';
    this.imageFile = null;
  }
  openCropFromExisting(base64: string) {
    fetch(base64)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], "image.png");
        this.imageFile = file;
        this.showCropper = true;
        this.showCropper = true;
        this._editingImageSrc = base64;
      });
  }
  cancelCrop() {
    this.showCropper = false;
    this.croppedImage = '';
    this._resolveCrop = null;
  }
  markDirty(name: string, html: string) {
    const initialMap: any = {
      description_SecB: this.initialContent1,
      description_SecB_2: this.initialContent6,
      description_SecB_3: this.initialContent7,
      description_SecC: this.initialContent2,
      description_SecC_2: this.initialContent8,
      description_SecC_3: this.initialContent9,
      description_SecC_4: this.initialContent10,
      description_SecD: this.initialContent3,
      description_SecFS: this.initialContent18,
      description_SecE: this.initialContent4,
      description_SecE_2: this.initialContent11,
      description_SecE_4: this.initialContent13,
      description_SecE_6: this.initialContent15,
      description_SecE_S7: this.initialContent17,
      trusteeStatement: this.initialContent16
    };
    if (html !== initialMap[name]) {
      this.isdirty = true;
      this.datashare.setisdirty(true);
    }
  }
  blockSymbols(event: KeyboardEvent): void {
    debugger
    if ((event.ctrlKey || event.metaKey) && ['c', 'v'].includes(event.key.toLowerCase())) {
      return;
    }
    const input = event.target as HTMLInputElement;
    const blockedKeys = ['+', '-', '.'];
    const allowedControlKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    if (blockedKeys.includes(event.key)) {
      event.preventDefault();
      return;
    }
    if (allowedControlKeys.includes(event.key)) {
      return;
    }
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
      return;
    }
    const currentValue = input.value;
    const selectionStart = input.selectionStart ?? 0;
    const selectionEnd = input.selectionEnd ?? 0;
    const isReplacing = selectionEnd > selectionStart;
    if (currentValue.length >= 8 && !isReplacing) {
      event.preventDefault();
    }
  }
  altchange(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    div.querySelectorAll('img').forEach((img: HTMLImageElement) => {
      let altValue = img.getAttribute('alt');
      if (!altValue || altValue.trim() === '') {
        altValue = 'image';
      }
      const attrs = Array.from(img.attributes);
      attrs.forEach(attr => {
        if (attr.name.toLowerCase() === 'alt') {
          img.removeAttribute(attr.name);
        }
      });
      img.setAttribute('alt', altValue);
    });
    return div.innerHTML;
  }
  blockPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const input = event.target as HTMLInputElement;
    const pasted = event.clipboardData?.getData('text') ?? '';
    let newValue = pasted.replace(/\D/g, '');
    newValue = newValue.slice(0, 8);
    input.value = newValue;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
  CreateCharityTrusteesForm() {
    this.CharityTrusteesFrom = this._formBuilder.group({
      name: new FormControl(null),
      is_chair: new FormControl(null),
      date_of_appointment: new FormControl(null, Validators.required),
      organisation_number: new FormControl(null),
      charity_name: new FormControl(null, Validators.minLength(3)),
      reg_charity_number: new FormControl(null),
      reporting_status: new FormControl(null),
      comissionTrustee_Id: new FormControl(null),
      trustee_Id: new FormControl(null)
    })
  }
  modalAddAdvisor(template: any) {
    debugger
    this.CreateCharityTrusteesForm();
    this.CharityTrusteesFrom.markAllAsTouched();
    let dialogRef = this.dialog.open(template, {
      /* width: '40%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true*/
      //width: '40%', maxWidth: '100%', maxHeight: 'auto', height: '88vh', disableClose: true,
      width: '30%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true, panelClass: 'custom-dialog-container'
    });
    this.chairOfBoardOptions = false
    this.CharityTrusteesFrom.reset();
  }

  applyFilterforTrustees(value?: any) {

    this.gettrusteeData.filterPredicate = (data: { name: string; }, filter: string) => {
      return data.name?.toLowerCase().startsWith(filter);
    };
    if (value == 'viewTrustee') {
      if (this.search_Trustee == null) {
        this.search_Trustee = '';
      }
      this.gettrusteeData.filter = this.search_Trustee.trim().toLowerCase();
      this.filterOver = this.gettrusteeData.filteredData.length;
    }
    if (value == 'addCharity') {
      this.trusteesData.filterPredicate = (data: { name: string; }, filter: string) => {
        return data.name?.toLowerCase().includes(filter);
      };
      this.trusteesData.filter = this.search_Trustee.trim().toLowerCase();
      this.registration_Number = ''
      if (this.trusteesData.filteredData) {
        this.filterTrustee = this.trusteesData.filteredData.length;
      }
      else {
        this.filterTrustee = this.trusteesData?.length;
      }
    }
  }

  closeTrustee() {
    debugger
    if (this.CharityTrusteesFrom.dirty) {
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">Are you sure you want to leave the page.<br\>Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          if (this.selectedTrusteeId) {
            this.tarDetails.approvedbyTrustee_SecA = this.selectedTrusteeId;
          }
          this.dialog.closeAll()
          this.applyFilterforTrustees('viewTrustee');
          return
        }
        else {
          return
        }
      })
    }
    else {
      if (this.selectedTrusteeId) {
        this.tarDetails.approvedbyTrustee_SecA = this.selectedTrusteeId;
      }
      this.CreateCharityTrusteesForm();
      this.dialog.closeAll()
    }
    return
  }
  AddAdvisor() {
    debugger
    if (!this.CharityTrusteesFrom.get('name')?.value) {
      this.CharityTrusteesFrom.get('name')?.setErrors({ required: true });
      this.CharityTrusteesFrom.get('name')?.markAsTouched();
    }
    if (!this.CharityTrusteesFrom.get('date_of_appointment')?.value) {
      this.CharityTrusteesFrom.get('date_of_appointment')?.setErrors({ required: true });
    }
    if (this.CharityTrusteesFrom.valid) {
      const charityId = +(localStorage.getItem('charityId') ?? '0');
      const form = this.CharityTrusteesFrom.getRawValue();
      this.dialog.closeAll();
    }
  }
  showChairOfBoard() {
    if (this.CharityTrusteesFrom.controls['is_chair'].value == true) {
      this.chairOfBoardOptions = true
    } else {
      this.chairOfBoardOptions = false
      this.CharityTrusteesFrom.controls['charity_name'].setValue(null)
      this.CharityTrusteesFrom.get('charity_name')?.markAsUntouched();
      this.CharityTrusteesFrom.controls['reg_charity_number'].setValue(null)
      this.CharityTrusteesFrom.get('reg_charity_number')?.markAsUntouched();
      this.CharityTrusteesFrom.controls['reporting_status'].setValue(null)
      this.CharityTrusteesFrom.get('reporting_status')?.markAsUntouched();
    }
  }
  validationstrustee(): boolean {
    if (!this.CharityTrusteesFrom.get('name')?.value) {
      this.CharityTrusteesFrom.get('name')?.setErrors({ required: true })
      this.CharityTrusteesFrom.get('name')?.markAsTouched()
    }
    if (!this.CharityTrusteesFrom.get('date_of_appointment')?.value) {
      if (!this.CharityTrusteesFrom.get('date_of_appointment')?.hasError('invalid')) {
        this.CharityTrusteesFrom.get('date_of_appointment')?.setErrors({ required: true })
        this.CharityTrusteesFrom.get('date_of_appointment')?.markAsTouched()
      }
    }
    if (this.chairOfBoardOptions) {
      if (!this.CharityTrusteesFrom.get('reporting_status')?.value) {
        this.CharityTrusteesFrom.get('reporting_status')?.setErrors({ required: true })
      }
      if (!this.CharityTrusteesFrom.get('reg_charity_number')?.value) {
        this.CharityTrusteesFrom.get('reg_charity_number')?.setErrors({ required: true })
      }
      if (!this.CharityTrusteesFrom.get('charity_name')?.value) {
        this.CharityTrusteesFrom.get('charity_name')?.setErrors({ required: true })
      }
      this.CharityTrusteesFrom.markAllAsTouched()
    }
    else {
      this.CharityTrusteesFrom.get('reporting_status')?.setErrors(null)
      this.CharityTrusteesFrom.get('reg_charity_number')?.setErrors(null)
      this.CharityTrusteesFrom.get('charity_name')?.setErrors(null)
    }
    if (!this.CharityTrusteesFrom.valid) {
      return false
    }
    return true
  }

  validateNew(event: any) {
    debugger
    if (event.target.value) {
      this.CharityTrusteesFrom.get('reg_charity_number')?.setValidators([])
      this.CharityTrusteesFrom.get('reg_charity_number')?.updateValueAndValidity();
    }
    if (event.target.value.length) {
      this.dupNum = this.trusteesData?.filteredData?.some((data: any) => data.reg_charity_number == event.target.value);
      if (this.dupNum != true) {
        this.dupNum = this.gettrusteeData?.filteredData?.some((data: any) => data.reg_charity_Number == event.target.value);
      }
      if (this.dupNum) {
        this.CharityTrusteesFrom.get('reg_charity_number')?.setErrors({ duplicate: true })
      }
    }
    else {
      this.dupNum = false;
    }
  }

  DbDateConverter(ControllerDate: any) {
    if (ControllerDate) {
      const momentDate = moment(ControllerDate);
      const localMidnight = momentDate.startOf('day');
      const formattedDate = localMidnight.format('YYYY-MM-DDTHH:mm:ss.SS[Z]');
      console.log(formattedDate);
      return formattedDate;
    } else {
      return null;
    }
  }
  saveTrustee(trusteeData?: any, btnenable?: any, index?: any) {
    debugger
    this.search_Trustee = ''
    this.onFirstClick = true
    if (this.trusteesData == undefined) {
      this.trusteesData = [];
    }
    if (this.trusteesArray == undefined) {
      this.trusteesArray = [];
    }
    if (btnenable == 'true') {
      if (!this.validationstrustee()) {
        this.onFirstClick = false
        return
      }
    }
    if (trusteeData != undefined) {
      const trusteeForm = this._formBuilder.group({
        name: [trusteeData?.name || null],
        is_chair: [trusteeData?.is_chair || null],
        date_of_appointment: [trusteeData?.date_of_appointment || null, Validators.required],
        organisation_number: [trusteeData?.organisation_number || null],
        charity_name: [trusteeData?.charity_name || null],
        reg_charity_number: [trusteeData?.reg_charity_number || null],
        reporting_status: [trusteeData?.reporting_status || null],
        comissionTrustee_Id: [trusteeData?.trustee_id || null],
        trustee_Id: [trusteeData?.trustee_id || null],
        fetchFromComission: [trusteeData?.fetchFromComission || null],
      });
      this.trusteesArray = this.trusteesArray.filter((L: any) =>
        !(L.comissionTrustee_Id === trusteeForm.controls['comissionTrustee_Id'].value &&
          L.fetchFromComission === trusteeForm.controls['fetchFromComission'].value)
      );
      this.trusteesArray.push(trusteeForm.getRawValue());
    }
    else {
      const updatedArraydata = {
        name: this.CharityTrusteesFrom.controls['name'].value,
        is_chair: this.CharityTrusteesFrom.controls['is_chair'].value,
        date_of_appointment: this.DbDateConverter(this.CharityTrusteesFrom.controls['date_of_appointment'].value),
        organisation_number: this.CharityTrusteesFrom.controls['organisation_number'].value,
        charity_name: this.CharityTrusteesFrom.controls['charity_name'].value,
        reg_charity_number: this.CharityTrusteesFrom.controls['reg_charity_number'].value,
        reporting_status: this.CharityTrusteesFrom.controls['reporting_status'].value,
        comissionTrustee_Id: this.CharityTrusteesFrom.controls['comissionTrustee_Id'].value,
        trustee_Id: this.CharityTrusteesFrom.controls['trustee_Id'].value
      }

      if (this.selectedTrusteeIndex != null) {
        this.trusteesArray[this.selectedTrusteeIndex] = updatedArraydata;
        this.selectedTrusteeIndex = null;
      } else {
        this.trusteesArray.push(updatedArraydata);
      }
    }
    const trusteeData1 = [...this.trusteesArray];
    this.trusteesData = new MatTableDataSource(trusteeData1);
    this.trusteesData.sort = this.sort1;
    this.filterTrustee = this.trusteesData.length
    if (this.paginatorT) {
      this.trusteesData.paginator = this.paginatorT;
    }
    this.recordsFound = this.trusteesData.filteredData.length;
    if (btnenable == 'true') {

      this.saveTrusteesData();
    } else {
      this.dialog.closeAll();
      this.onFirstClick = false
      if (btnenable == 'true') {
        var Messagge = this.editable ? 'updated' : 'created'
        this.msgService.showToastMessage('success', `Trustee ${Messagge} successfully`)
      }
    }
    if (this.trusteesArray.length > 0) {
      this.skpbtn = true;
      this.recordsFound = this.trusteesData.filteredData?.length;
    }
    else {
      this.skpbtn = false;
    }
  }
  saveTrusteesData() {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      var CenUserId = parsedUser.centralUserID;
      var UserID = parsedUser.userID;
    }
    var CharityId = localStorage.getItem('charityId');
    for (let i = 0; i < this.trusteesArray.length; i++) {

      this.trusteesArray[i].centralUserId = +(CenUserId == null ? 0 : CenUserId);
      this.trusteesArray[i].charityId = +(CharityId == null ? 0 : CharityId);
      this.trusteesArray[i].userId = +(UserID == null ? 0 : UserID);
    }
    this.trusteesArray.filter((item: any) => {
      item.organisation_number = (item.organisation_number != null && item.organisation_number) ? item.organisation_number.toString() : null,
        item.reg_charity_number = (item.reg_charity_number != null && item.reg_charity_number) ? item.reg_charity_number.toString() : null
    })
    var modal = new TrusteesDataModal();
    modal = this.trusteesArray;
    this.Charities_Service.SaveTrusteesData(modal).subscribe((data: any) => {
      if (data.mesage != null) {
        this.tarDetails.approvedbyTrustee_SecA = data?.status;
        this.selectedTrusteeId = data?.status;
        this.msgService.showToastMessage('success', data.mesage)
        this.dialog.closeAll();
        this.GetTrustees();
      }
    })
  }
  GetTrustees() {
    debugger
    var fid = localStorage.getItem('currentPeriod')
    this.apiservice.GetTAR(fid).subscribe((data: any) => {
      if (data.trustees) {
        this.trustees = data.trustees
      }
    })
  }
  GetTrusteeData() {
    debugger
    const charityId = +(localStorage.getItem('currentCharityID') ?? '0');
    this.Charities_Service.GetTrusteeDetails(charityId).subscribe((data: any) => {
        if (data?.entity) {
          this.gettrusteeData = new MatTableDataSource(data.entity);
        }
      });
  }
  vldtrusteedateofapp(event: any) {
    this.CharityTrusteesFrom.get('date_of_appointment')?.setErrors(null)
    if (event.target.value == null || event.target.value == "") {
      this.CharityTrusteesFrom.get('date_of_appointment')?.setErrors({ required: true })
      this.CharityTrusteesFrom.get('date_of_appointment')?.markAsTouched()
      return
    }
    if (moment(event.target.value, 'DD/MM/YYYY', true).isValid()) {
      var appdate = moment(event.target.value, 'DD/MM/YYYY');
      const today = moment();
      if (appdate.isAfter(today)) {
        this.CharityTrusteesFrom.get('date_of_appointment')?.setErrors({ date: true });
        return;
      }
      var dateofRemoval = localStorage.getItem('date_of_Removal');
      if (dateofRemoval) {
        const dateofremove1 = moment(dateofRemoval, 'DD/MM/YYYY')
        const dateofremove = moment(moment(dateofRemoval).format('DD/MM/YYYY'), 'DD/MM/YYYY')
        var checkdate = dateofremove1.isValid() ? dateofremove1 : dateofremove
        if (appdate.isAfter(checkdate)) {
          this.CharityTrusteesFrom.get('date_of_appointment')?.setErrors({ Removaldate: true });
        }
      }
    }
    else {
      this.CharityTrusteesFrom.get('date_of_appointment')?.setErrors({ invalid: true })
      return
    }
  }
  selectedTrusteeId: any;
  onTrusteeChange(event: MatSelectChange, type?: any): void {
    debugger
 
    if (event.value) {
      this.selectedTrusteeId = null;
      this.selectedTrusteeId = event.value;
    } else {
      this.selectedTrusteeId = this.selectedTrusteeId;
    }
  }

  allowedKeys: string[];
  restrictInput(event: KeyboardEvent): void {
    const allowedControlKeys = ['Backspace','Delete','Tab','Enter','ArrowLeft','ArrowRight','Home','End'];
    if (allowedControlKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
      return;
    }
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }
}
const descriptionFields: string[] = [
  'description_SecB',
  'description_SecB_2',
  'description_SecB_3',
  'description_SecC',
  'description_SecC_2',
  'description_SecC_3',
  'description_SecC_4',
  'description_SecD',
  'description_SecE',
  'description_SecE_2',
  'description_SecE_3',
  'description_SecE_4',
  'description_SecE_5',
  'description_SecE_6',
  'description_SecFS'
];
